import { render, staticRenderFns } from "./admin.layout.f4400550.vue?vue&type=template&id=09012be2&"
import script from "./admin.layout.f4400550.vue?vue&type=script&lang=js&"
export * from "./admin.layout.f4400550.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports